import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-add-team-team-membership',
  templateUrl: './add-team-team-membership.component.html',
  styleUrls: ['./add-team-team-membership.component.scss'],
})
export class AddTeamTeamMembershipComponent {
  activatedRoute: any;
  modalLabel: any;
  teamMemberForm!: FormGroup;
  teamMemberData: any;
  userList: any;
  isReadOnly!: boolean;
  submitted!: boolean;
  @Output() saveTeamsTeamMembershipEvent = new EventEmitter<any>();
  roleListNew: any;
  selectUser: any;
  selectRole: any;

  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    private router: Router
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.teamMemberData = this.modal?.modalService?.config?.initialState?.['newTeamMemberData'];
    this.userList = this.teamMemberData.userItems;

    this.roleListNew = this.teamMemberData.roleItems;
    this.roleListFunction();

    this.userList = this.teamMemberData.userItems;
    this.userListFunction();
  }
  ngOnInit() {
    this.teamMemberForm = this.formBuilder.group({
      userName: [null, Validators.required],
      roleName: [null, [Validators.required]],
    });
    this.setFormData();
  }
  async userListFunction() {
    await this.userList.map((item: any) => {
      if (item.id == this.teamMemberData.userId) {
        return (this.selectUser = item);
      }
    });
  }
  async roleListFunction() {
    await this.roleListNew.map((item: any) => {
      if (item.id == this.teamMemberData.roleId) {
        return (this.selectRole = item);
      }
    });
  }

  setFormData() {
    this.teamMemberForm.patchValue({ userName: this.selectUser, roleName: this.selectRole });
  }
  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  onSave() {
    this.submitted = true;
    if (this.teamMemberForm.invalid) {
      this.submitted = true;
      return;
    } else {
      let urlSlash = this.router.url.lastIndexOf('/');
      let teamId = this.router.url.slice(urlSlash + 1);
      const data = {
        id: this.teamMemberData.id,
        userId: this.teamMemberForm.controls['userName'].value?.id,
        roleId: this.teamMemberForm.controls['roleName'].value?.id || null,
        teamId: this.teamMemberData.teamId || teamId,
      };
      this.saveTeamsTeamMembershipEvent.emit(data);
      this.modal.close();
    }
  }

  onClose() {
    this.modal.close();
  }
}
